import React, { useContext, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import Button from "../../components/core/EPL_Button_Think";
import useMediaQuery from "../../hooks/useMediaQuery";
import ErrorModal from "../../modals/ErrorModal";
import { UserContext } from "../../shared/context/UserContext";
// import VendorService from '../../shared/services/VendorService';
// import sendRequest from '../../shared/utils/sendRequest';
import { isValidDateOfBirth } from "../../shared/validations/DateOfBirth";
import { isValidEmail } from "../../shared/validations/Email";
import sendRequest from "../../utils/sendRequest";
// import Progress from '../progress/Progress';
import {
  IncorrectPinCodeModal,
  CheckInternetModal,
  NsdlPanFailed,
  RejectActivePANModal,
  PanValidationReject,
  NsdlApiDown,
  VerifyNameOnPANModal
} from "../other-pages/Modals/AllModal";
// import Summary from '../summary/Summary';
import FloatingInput from "../../components/base/FloatingInput.js";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import { isValidPAN } from "../../shared/validations/PAN";
import { isValidPincode } from "../../shared/validations/Pincode";
import { encrypt } from "../../utils/crypto";
import { PersonalDetailsWrapper } from "./_styles/PersonalDetailsWrapper";
// import basicArt from "../../assets/svg/EPL_think_svg/Personal_Details_Art.min.svg";
// import basicArt from "../../assets/svg/EPL_think_svg/DetailsGraphic1.svg";
import {
  GetCustomerDetailsContext,
  GetCustomerDetails,
  validateInputExistenece,
} from "../../App";
import {
  BUREAU_CIBIL,
  // CKYC_INIT,
  PINCODE_MASTER,
  SAVE_BASIC_DETAILS,
  UPDATE_USER_CONSENT_STATUS,
  VERIFY_PAN,
  VERIFY_PAN_V2,
} from "../../Config";
import CalendarIcon from "../../assets/svg/EPL_think_svg/Icon_Calendar.svg";
import CheckField from "../../components/form/CheckField";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import ScenarioBasedBottomModal from "../other-pages/Modals/ScenarioBasedBottomModal";
import { updateLead } from "../../shared/services/crm";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import isEnglish, { isEnglishNewCheck } from "../../shared/validations/isEnglish.js";
import { isValidAddress } from "../../../../epl_upsell/src/shared/validations/Address.js";
import { userConsentStatus } from "../../utils/userConsentStatus.js";
import { encryptedData } from "../../utils/index.js";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const getInternalStage = (stage, stage_status) => {
  if (stage === "BASIC_INFO" && stage_status === "INIT") {
    return "BASIC_INFO_INIT";
  } else if (stage === "CCC" && stage_status === "INIT") {
    return "CCC_INIT";
  } else {
    return "BASIC_INFO_INIT";
  }
};

const PersonalDetails = (props) => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  // const [customerDetails, setCustomerDetails] = useState(props.customerDetails);
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(true);
  const [activePanRejection, setActivePanRejection] = useState(false);

  const [iosStyle, setIOSstyle] = useState("");

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      setShowShimmer(false);
      // console.log("PersonalDetails customerDetails: ", customerDetails);
      if (customerDetails.stage === "PROFESSIONAL_START") {
        // console.log("Redirecting customerDetails to /details");
        props.changeDetailsType(1);
        navigate("/details", {
          replace: true,
          customerDetails: customerDetails,
        });
      }
      setApprovedLoanAmount(parseInt(customerDetails?.Data?.max_topup) || 0);
      setShowBottomModal(
        customerDetails.source === "upsell" ||
          customerDetails.Data.journey_type === "preapproved"
          ? true
          : false || false
      );
      // TODO: Change based on NSDL stage
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log(customerDetails.source);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      if (customerDetails?.Data?.isError === "True") {
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          // if (customerDetails?.Data?.api_name === "bureauCall") {
          //   console.log(">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
          //   await callCibil();
          // }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // console.log("PersonalDetails Ouch customerDetails ");
    }
  }, [customerDetails]);

  useEffect(()=>{
    
    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setTimeout(() => {
      moengage.track_event("preApproved", {
        preApproved: customerDetails.source === "upsell"? "YES" : customerDetails.Data.journey_type === "preapproved"? "YES":"NO",
        offeredAmount: parseInt(customerDetails?.Data?.max_topup) || 0,
        application_form_number: sessionStorage.getItem(
          "application_form_no"
        ),
        "journey name": customerDetails.source,
      });
    }, 1000);
  },[])

  useEffect(() => {
    if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
      setIOSstyle("ios");
    }
  });

  const [internalStage, setInternalStage] = useState();

  const { user, setUser } = useContext(UserContext);
  const [fullName, setName] = useState("");
  const [internetCheck, setInternetCheck] = useState(false);
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [pincodeMasterError, setPincodeMasterError] = useState(false);
  const dropDownLabels = ["Single", "Married", "Divorced"];
  const [maritalStatus, setMaritalStatus] = useState("");
  const [maritalStatusError, setMaritalStatusError] = useState("");
  const [panDisabled, setPanDisbaled] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [gender, setGender] = useState("");
  const [maleDisabled, setMaleDisabled] = useState(false);
  const [femaleDisabled, setFemaleDisabled] = useState(false);
  const [nsdlDown, setNsdlDown] = useState(false);
  const [showVerifyNameModal, setShowVerifyNameModal] = useState(false);
  const [residentialAddress, setResidentialAddress] = useState("");
  const [residentialAddressError, setResidentialAddressError] = useState(false);
  const [residentialAddressErrorMessage, setResidentialAddressErrorMessage] = useState("Please enter a valid address");
  const [residentialAddress1, setResidentialAddress1] = useState("");
  const [residentialAddress1Error, setResidentialAddress1Error] = useState(false);
  const [residentialAddress1ErrorMessage, setResidentialAddress1ErrorMessage] = useState("Please enter a valid address");

  const updateResidentialAdd = (e) => {
    const add = e.target.value;

    setResidentialAddress(add);

    const minLength = 1;

    const validationResult = isValidAddress(add, minLength);

    if (!validationResult.isValid) {
      setResidentialAddressError(true);
      setResidentialAddressErrorMessage(validationResult.message);
    } else {
      setResidentialAddressError(false);
    }
  };

  const updateResidentialAdd1 = (e) => {
    const add = e.target.value;

    setResidentialAddress1(add);

    const validationResult = isValidAddress(add);

    if (!validationResult.isValid) {
      setResidentialAddress1Error(true);
      setResidentialAddress1ErrorMessage(validationResult.message);
    } else {
      setResidentialAddress1Error(false);
    }
  };  

  const updateGender = (e) => {
    setGender(e.target.value);
    // console.log("selected", e.target.value);
  };
  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };
  const dropDownChange = (filterText) => {
    setMaritalStatus(filterText);
    setDropDownOptions(createDropDownOptions(true, filterText));
    // // console.log("selectedOption: ", e.tartget.value);
  };
  const createDropDownOptions = (isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < dropDownLabels.length; i++) {
      if (
        isFilter &&
        dropDownLabels[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: dropDownLabels[i],
          value: dropDownLabels[i],
          func: () => {
            setMaritalStatus(dropDownLabels[i]);
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: dropDownLabels[i],
          value: dropDownLabels[i],
          func: () => {
            setMaritalStatus(dropDownLabels[i]);
            showDropdown();
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setMaritalStatus("");
          showDropdown();
        },
      });
    }
    return options;
  };
  const [genderEditable, setGenderEditable] = useState();
  const [maritalStatusDisabled, setMaritalStatusDisabled] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  // const [residenceStatus, setResidenceStatus] = useState(user.home_premise_type || '');
  const [residenceStatusDisabled, setResidenceStatusDisabled] = useState(false);
  const [personalEmail, setPersonalEmail] = useState("");
  const [personalEmailDisabled, setPersonalEmailDisabled] = useState(false);
  const [personalEmailError, setPersonalEmailError] = useState(false);
  const [personalEmailErrorMessage, setPersonalEmailErrorMessage] = useState(
    "Incorrect Email Format!"
  );
  const personalEmailInfoMessage =
    "Please click on 'Verify Email' button to validate your Email!";
  const [
    personalEmailVerifyButtonVisible,
    setPersonalEmailVerifyButtonVisible,
  ] = useState(true);
  const [
    personalEmailVerifyButtonDisabled,
    setPersonalEmailVerifyButtonDisabled,
  ] = useState(false);
  const [personalEmailVerified, setPersonalEmailVerified] = useState(false);
  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [consentCheckbox2, setConsentCheckbox2] = useState(false);

  const [modal, setModal] = useState("");
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(true);
  const [pincodeInfoMessage, setPincodeInfoMessage] = useState(
    "Required so we can service you better"
  );
  const [
    pincodeServiceableButtonDisabled,
    setPincodeServiceableButtonDisabled,
  ] = useState(true);
  const [PAN, setPAN] = useState(String(""));
  const [PANError, setPANError] = useState(false);
  const [PANErrorMessage, setPANErrorMessage] = useState(
    "Please enter Valid PAN"
  );
  const [nsdlFailed, setNsdlFailed] = useState(false);
  const [saDataPincode, setSADataPincode] = useState("");
  const [PANVerified, setPANVerified] = useState(false);
  const [pincodeDisabled, setPincodeDisabled] = useState(false);
  const [pincode, setPincode] = useState("");
  const [pincodeError, setPincodeError] = useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");
  const [pincodeVerified, setPincodeVerified] = useState(false);
  const [checkBoxDisabled, setCheckBoxDisabled] = useState(true);

  const [dob, setDOB] = useState("");
  const [dobError, setDOBError] = useState(false);
  const [dobDD, setDOBDD] = useState("");
  const [dobErrorMessage, setDOBErrorMessage] = useState("");
  const [dobDisabled, setDOBDisabled] = useState(false);
  const [isUpsellDOb, setIsUpsellDOb] = useState(false);
  const [dobDDError, setDOBDDError] = useState(false);
  const [dobDDErrorMessage, setDOBDDErrorMessage] = useState("");
  const [dobMM, setDOBMM] = useState("");
  const [dobMMError, setDOBMMError] = useState(false);
  const [dobMMErrorMessage, setDOBMMErrorMessage] = useState("");
  const [dobYYYY, setDOBYYYY] = useState("");
  const [dobYYYYError, setDOBYYYYError] = useState(false);
  const [dobYYYYErrorMessage, setDOBYYYYErrorMessage] = useState("");

  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState(false);
  const [cityErrorMessage, setCityErrorMessage] = useState("");
  const [cityVerified, setCityVerified] = useState(false);
  const [cityDisabled, setCityDisabled] = useState(true);

  const [state, setState] = useState("");
  const [stateError, setStateError] = useState(false);
  const [stateErrorMessage, setStateErrorMessage] = useState("");
  const [stateVerified, setStateVerified] = useState(false);
  const [stateDisabled, setStateDisabled] = useState(true);

  const [showBottomModal, setShowBottomModal] = useState(false);
  const [approvedLoanAmount, setApprovedLoanAmount] = useState(0);
  const [dobType, setDobType] = useState(customerDetails?.source === "upsell");
  // const [nsdlFailed, setNsdlFailed] = useState(false);
  const [panValidationReject, setPanValidationReject] = useState(false);

  const updateDOBDD = (e) => {
    setDOBDD(e.target.value);
    setDOB(dobYYYY + "-" + dobMM + "-" + e.target.value);
  };

  const updateDOBMM = (e) => {
    setDOBMM(e.target.value);
    setDOB(dobYYYY + "-" + e.target.value + "-" + dobDD);
  };

  const updateDOBYYYY = (e) => {
    setDOBYYYY(e.target.value);
    setDOB(e.target.value + "-" + dobMM + "-" + dobDD);
  };


  const isValidDate = (dateString) => {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (!dateRegex.test(dateString)) {
      return false;
    }
    const [day, month, year] = dateString.split("/").map(Number);

    if (month < 1 || month > 12) {
      return false;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return false;
    }

    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

    if (month === 2) {
      if (isLeapYear && day > 29) {
        return false;
      } else if (!isLeapYear && day > 28) {
        return false;
      }
    }
    if (year < 1000 || year > 9999) {
      return false;
    }

    const currentDate = new Date();
    const birthDate = new Date(year, month - 1, day);

    const age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())
    ) {
      // Subtract 1 year if birthdate hasn't occurred yet this year
      return age - 1 >= 23 && age - 1 <= 59;
    } else {
      return age >= 23 && age < 59;
    }
  };


  const updateDateOfBirth = (e) => {
    let dobInput = e.target.value;
    let value = dobInput.replace(/\D/g, "");

    if (dobInput.length <= 10) {
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      if (value.length > 5) {
        value = value.slice(0, 5) + "/" + value.slice(5);
      }
      setDOB(value);
      // console.log(value.length);
      if (value.length === 10) {
        setDOBError(!isValidDate(value));
      } else {
        setDOBError(true);
      }
    }
  };

  const updateName = (e) => {
    setNameError(false);
    setName(e.target.value.toLocaleUpperCase());
    if (e.target.value.toLocaleUpperCase().length === 0) {
      setNameError(true);
    }
    if (!isEnglishNewCheck(e.target.value)) {
      setNameError(true);
    }
  };

  const updatePersonalEmail = (e) => {
    setPersonalEmail(e.target.value);
    setPersonalEmailError(!isValidEmail(e.target.value));
    setPersonalEmailVerified(false);
  };

  const validatePAN = () => {
    // console.log("In validatePAN");
    if (isValidPAN(PAN)) {
      // console.log("... PAN Valid");
      setPANError(false);
      setPANErrorMessage("");
      setPANVerified(true);
      return true;
    } else {
      // console.log("... PAN InValid");
      setPANError(true);
      setPANErrorMessage(PANErrorMessage);
      setPANVerified(false);
      return false;
    }
  };

  const validateDOB = () => {
    // console.log("In validateDOB", dob, isValidDateOfBirth(dob));
    setDOBError(!isValidDateOfBirth(dob));
    setDOBDDError(!isValidDateOfBirth(dob));
    setDOBMMError(!isValidDateOfBirth(dob));
    setDOBYYYYError(!isValidDateOfBirth(dob));
    setDOBErrorMessage(!isValidDateOfBirth(dob) ? "Enter Valid DOB" : "");
    return isValidDateOfBirth(dob);
  };

  const validatePersonalEmail = () => {
    // console.log("In validatePersonalEmail");
    if (isValidEmail(personalEmail)) {
      // console.log("... personalEmail Valid");
      setPersonalEmailError(false);
      setPersonalEmailErrorMessage("");
      setPersonalEmailVerifyButtonVisible(true);
      setPersonalEmailVerifyButtonDisabled(false);
      return true;
    } else {
      // console.log("... personalEmail InValid");
      setPersonalEmailError(true);
      setPersonalEmailErrorMessage("Incorrect Email");
      setPersonalEmailVerifyButtonVisible(true);
      setPersonalEmailVerifyButtonDisabled(false);
      return false;
    }
  };

  const validateData = () => {
    return (
      validatePAN() &&
      // &&  isValidName(fullName) && // As Full Name is not editable
      validateDOB(dob) &&
      validatePersonalEmail()
    );
    // && isValidGender(gender);
  };

  const [personalAuthContact, setPersonalAuthContact] = useState(false)
  const [personalIncomeConfirm, setPersonalIncomeConfirm] = useState(false)

  const updateConsentCheckbox = () => {
    setPersonalAuthContact(!personalAuthContact);

    // console.log("In updateConsentCheckbox");
    // if (validateData()) {
    // console.log("In if");
    setConsentCheckbox(!consentCheckbox);
    if (consentCheckbox && consentCheckbox2) {
      setOnSubmitButtonDisabled(false);
    } else {
      setOnSubmitButtonDisabled(true);
    }
    // } else {
    // setConsentCheckbox(false);
    // // console.log("In else");
    // }
  };

  const updateConsentCheckbox2 = () => {
    setPersonalIncomeConfirm(!personalIncomeConfirm);

    setConsentCheckbox2(!consentCheckbox2);
    if (consentCheckbox && consentCheckbox2) {
      setOnSubmitButtonDisabled(false);
    } else {
      setOnSubmitButtonDisabled(true);
    }
  };

  useEffect(async () => {
    moengage.track_event("personal_OSM", {
      pageLoad: "YES",
    });

    // console.log("UUID:  ",customerDetails.Data.uuid);
    // moengage.add_unique_user_id(customerDetails.Data.uuid);

    setTimeout(function() {
      // console.log('sssssss');
      moengage.add_mobile(customerDetails.Data.mobile);
    }, 2000);
    // console.log("useEffect details->", customerDetails.stage);
    // console.log("I AM HERE", customerDetails.application_form_number);
    // window.scrollTo(0, 0);
    {
      await GetCustomerDetails(
        customerDetails.application_form_number,
        customerDetails.source,
        customerDetails,
        setCustomerDetails
      );
      // setPAN(customerDetails);
    }
    setDropDownOptions(createDropDownOptions());
  }, []);

  useEffect(async () => {
    // console.log(customerDetails);
    if (customerDetails?.Data?.isError !== "True") {
      if (
        customerDetails.source === "upsell" ||
        customerDetails.Data?.journey_type === "preapproved"
      ) {
        if (isValidPAN(customerDetails?.Data.pan)) {
          setPAN(customerDetails.Data.pan);
        }
        if (customerDetails?.source === "upsell") {
          setPanDisbaled(true);
        }
        if (customerDetails.Data?.journey_type === "preapproved") {
          if (
            customerDetails?.Data?.pan === "" ||
            customerDetails?.Data?.pan === null ||
            customerDetails?.Data?.pan === undefined ||
            customerDetails?.Data?.pan === "None"
          ) {
            setPanDisbaled(false);
          } else {
            setPanDisbaled(true);
          }
        }
        if (customerDetails?.source === "upsell") {
          setName(
            customerDetails.Data.first_name +
              " " +
              customerDetails.Data.middle_name +
              " " +
              customerDetails.Data.last_name
          );
        }
        if (
          customerDetails.Data.gender.toUpperCase() === "MALE" ||
          customerDetails.Data.gender.toUpperCase() === "M"
        ) {
          setGender("Male");
        } else {
          setGender("Female");
        }
        setMaleDisabled(false);
        setFemaleDisabled(false);
        // updateGender()
        if (
          customerDetails?.Data?.date_of_birth !== "" &&
          customerDetails?.Data?.date_of_birth !== null &&
          customerDetails?.Data?.date_of_birth !== undefined &&
          customerDetails?.Data?.date_of_birth !== "None"
        ) {
          // console.log(customerDetails?.Data.date_of_birth);
          if (customerDetails?.source === "upsell") {
            setIsUpsellDOb(customerDetails.Data.journey_type === "preapproved");
            const tempDob = customerDetails?.Data?.date_of_birth.split(" ")[0];
            setDOB(tempDob);
            setDOBError(!isValidDateOfBirth(tempDob));
            setDOBDisabled(true);
          }
        }
        if (customerDetails.Data.journey_type === "preapproved") {
          setDOBDisabled(false);
        }
        setMaritalStatus(customerDetails.Data.marital_status);
        setPersonalEmailError(
          !isValidEmail(customerDetails.Data.personal_email_id)
        );
        setPersonalEmail(customerDetails.Data.personal_email_id);
        // if (customerDetails.Data.pincode != "") {
        if(isValidPincode(customerDetails.Data.pincode)) {
          setPincode(customerDetails.Data.pincode);
          await pinCodeMaster(customerDetails.Data.pincode);
        }
      }
      if (customerDetails?.Data.journey_type === "preapproved") {
        if (isValidPAN(customerDetails?.Data.pan)) {
          // await callNSDL(customerDetails.Data.pan);
        }
      }
    }
  }, []);
  // console.log(customerDetails);

  // const callCkycInitAPI = async () => {
  //   // console.log("Inside callCkycInitAPI");
  //   try {
  //     setShowShimmer(true);
  //     const formData = new FormData();
  //     const requestData = {
  //       // application_form_no: user.application_form_no,
  //       // account_id: "PHONEPE0000000051",
  //       application_form_no: customerDetails.application_form_number,
  //     };
  //     // setUser({
  //     //   ...user,
  //     //   account_id: search_params['account_id']
  //     // })
  //     // formData1.append('Selfie', finalZip, 'selfie.zip');
  //     formData.append("data", encryptedData(requestData));
  //     //formData1.append('base64', finalBase64Image);
  //     // history.replace({ pathname: `/${VendorService.vendor_name}${route}` });
  //     try {
  //       const response = await sendRequest(
  //         "/" + customerDetails.source + CKYC_INIT,
  //         formData
  //       );
  //       // console.log("callCkycInitAPI: response => ", response);
  //       // // console.log(response.Success);
  //       setShowShimmer(false);
  //       if (true) {
  //         // setUser({
  //         //   ...user,
  //         //   zId: response.
  //         // })
  //         // setUser({
  //         //   ...user,
  //         //   process_instance_id: response.CKYC_Z_REQUEST_ID
  //         // })
  //         // // console.log(response.CKYC_Z_REQUEST_ID);
  //         // setZId(response.CKYC_Z_REQUEST_ID);
  //         // // console.log(zId);
  //         // // console.log("Success true");
  //         // await ckycApi();
  //         // await faceMatch();
  //         // // console.log(user);
  //         // await pollingApi();
  //       }
  //     } catch (error) {
  //       setShowShimmer(false);
  //       // console.error(`callCkycInitAPI: Unknown Error: ${error}`);
  //       // var route = getRouteFromLoanStageService({
  //       //   source: customerDetails.source,
  //       //   stage: "error",
  //       // });
  //       // // // console.log("stage: ", customerDetails.stage);
  //       // // console.log("route: ", route);
  //       // navigate(`${route}`, {
  //       //   replace: true,
  //       // });
  //     }
  //   } catch (error) {
  //     setShowShimmer(false);
  //     // console.log(error);
  //     // var route = getRouteFromLoanStageService({
  //     //   source: customerDetails.source,
  //     //   stage: "error",
  //     // });
  //     // // // console.log("stage: ", customerDetails.stage);
  //     // // console.log("route: ", route);
  //     // navigate(`${route}`, {
  //     //   replace: true,
  //     // });
  //   }
  // };

  useEffect(() => {
    if (internalStage === "NSDL_COMPLETE") {
      //call getCustomerDetails to get name and pan
    } else {
    }
  }, [internalStage]);

  // console.log("CHECKKK->", customerDetails.stage);

  const callSaveBasicDetailsAPI = async () => {

    function generateTimestamp() {
      const now = new Date();
    
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Add leading zero for single-digit months
      const day = String(now.getDate()).padStart(2, '0'); // Add leading zero for single-digit days
    
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');
    
      const timestamp = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
    
      return timestamp;
    }
    
    const timestamp = generateTimestamp();
    // console.log(timestamp);
    moengage.track_event("personal", {
      journeyName: customerDetails.source,
      name: fullName, // string
      gender: gender, // numeric value
      "Personal email": personalEmail, // numeric value
      pincode: pincode, // datetime value. Example value represents 31 January, 2017.
      timestamp: timestamp,
    });
    moengage.add_email(personalEmail);
    moengage.add_user_name(fullName);

    // console.log("Inside callSaveBasicDetailsAPI");
    let result = "";
    if (customerDetails?.source === "epl") {
      const [day, month, year] = dob.split("/").map(Number);
      // Create a Date object
      const dateObject = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript Date
      // Extract the components
      const yyyy = dateObject.getFullYear().toString().padStart(4, "0");
      const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
      const dd = dateObject.getDate().toString().padStart(2, "0");

      // Concatenate the components in "yyyy-mm-dd" format
      result = `${yyyy}-${mm}-${dd}`;
    }
    if (consentCheckbox && consentCheckbox2) {
      try {
        setShowShimmer(true);
        // console.log("callSaveBasicDetailsAPI: try block");
        const formData = new FormData();
        const requestData = {
          application_form_no: customerDetails.application_form_number,
          date_of_birth: customerDetails?.source === "upsell" ? dob : result,
          personal_email_id: personalEmail,
          marital_status: maritalStatus,
          pincode: pincode,
          city: city,
          state: state,
          current_stage: customerDetails?.stage,
          gender: gender,
        };
        if(customerDetails?.source === "epl" ){
          requestData.residential_address = `${residentialAddress} ${residentialAddress1}`;
        }
        formData.append("data", encryptedData(requestData));
        // console.log("SABEBASIC PAYLOAD ->", requestData);
        const response = await sendRequest(
          "/" + customerDetails.source + SAVE_BASIC_DETAILS,
          formData
        );

        // console.log("callSaveBasicDetailsAPI: response => ", response);
        // console.log(
        //   "callSaveBasicDetailsAPI: response.data => ",
        //   response.data
        // );

        setShowShimmer(false);
        if (response.response.Success === true) {
          // console.log("callSaveBasicDetailsAPI: inside success");
          // await callCkycInitAPI();
          if (customerDetails.source === "epl") {
            updateLead(
              customerDetails.source,
              50,
              customerDetails.application_form_number
            );
            // if (customerDetails?.Data.journey_type !== "preapproved") {
            //   await callCibil();
            // }
          } else {
            updateLead(
              customerDetails.source,
              50,
              customerDetails.application_form_number
            );
          }
          setInternalStage(response.response.STAGE);
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          setShowShimmer(false);
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          }
          // console.log("callSaveBasicDetailsAPI: catch block => ", error);
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      }
    }
  };

  const callCibil = async () => {
    // console.log("Inside callNSDL");
    try {
      const payload = {
        application_form_no: customerDetails.application_form_number,
        loan_type: "HOUSING LOAN",
        requested_loan_amount: "70000",
        source_system: "DIRECT",
        source_system_vendor: "EPL",
        env: "DEV",
        tenure: "48",
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + BUREAU_CIBIL,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        setShowShimmer(false);
        if (response.response.Success === true) {
          //pass
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          console.error(`Unknown Error: ${error}`);
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      // console.log(error);
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
    setPANError(false);
    setPANVerified(true);
  };

  const verifyPANV2 = async () => {
    try {
      let result = "";
      if (customerDetails?.source === "epl") {
        const [day, month, year] = dob.split("/").map(Number);
        const dateObject = new Date(year, month - 1, day);

        const yyyy = dateObject.getFullYear().toString().padStart(4, "0");
        const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        const dd = dateObject.getDate().toString().padStart(2, "0");

        // Concatenate the components in "yyyy-mm-dd" format
        result = `${yyyy}-${mm}-${dd}`;
      }
      // console.log(customerDetails);
      const payload = {
        panNo: PAN,
        application_form_no: customerDetails?.application_form_number,
        dateOfBirth: customerDetails?.source === "upsell" ? dob : result,
        nameOnPAN: fullName,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + VERIFY_PAN_V2,
        formData
      );

      if (response.response.Message === "SUCCESS_REJECTED") {
        // console.log(">>>>>>>>>>>>>>HERE<<<<<<<<<<<<<<<<<");
        setShowShimmer(true);
        setActivePanRejection(true);
      }
      if (response.response.Message === "NSDL verification done") {
        moengage.track_event("personal_pan", {
          Is_Pan_Verified: "yes", //string
          journeyName: customerDetails.source,
        });
        await callSaveBasicDetailsAPI();
      }
      if (response.response.Message === "Aadhaar PAN Link Failure") {
        setPANError(true);
        setPANErrorMessage("PAN not linked with AADHAAR");
      }
      if (response.response.Message === "Name is mismatched") {
        moengage.track_event("personal_pan", {
          Is_Pan_Verified: "no", //string
          journeyName: customerDetails.source,
        });
        if (response.response.ReceivedName) {
          setName(response.response.NameRecievedFromIdfy);
          setShowVerifyNameModal(true);
        }
        else {
          setNameErrorMessage("Enter full name as per PAN");
          setNameError(true);
        }
        setShowShimmer(false);
      }
      if (response.response.Message === "DOB is mismatched") {
        moengage.track_event("personal_pan", {
          Is_Pan_Verified: "no", //string
          journeyName: customerDetails.source,
        });
        setDOBError(true);
        setDOBErrorMessage("Enter date of birth as per PAN");
        setShowShimmer(false);
      }
      // console.log(response.response.Message);
      if (response.response.Message === "PAN Invalid") {
        setPANError(true);
        setPANErrorMessage("Please enter Valid PAN");
      }
      if (response.response.Message === "NSDL_FAILED"){
        setNsdlDown(true);
        setShowShimmer(false);
      }
      if (
        response.response.Message === "Maximum retry for application number"
      ) {
        moengage.track_event("personal_pan", {
          Is_Pan_Verified: "no", //string
          journeyName: customerDetails.source,
        });
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "rejected",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        setShowShimmer(false);
      }
      setShowShimmer(false);
    } catch (error) {
      if (error.message === "API call cancelled due to connectivity issue") {
        setInternetCheck(true);
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            63,
            customerDetails.application_form_number
          );
        }
        console.error(`Unknown Error: ${error}`);
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });

          navigate(`${route}`, {
            replace: true,
          });
        }
        // setShowPanApiFailedModal(true);
      }
    }
  };

  const callNSDL = async (pan_no) => {
    // console.log("Inside callNSDL");
    try {
      const payload = {
        panNo: pan_no,
        appliction_form_no: customerDetails.application_form_number,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + VERIFY_PAN,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        setShowShimmer(false);
        if (response.response.Success === true) {
          if (response.response.Message === "SUCCESS_REJECTED") {
            setShowShimmer(true);
            setActivePanRejection(true);
          } else {
            setInternalStage(response.response.STAGE);
            if (customerDetails.Data.journey_type !== "preapproved") {
              setMaleDisabled(false);
              setFemaleDisabled(false);
              setDOBDisabled(false);
            }
            setMaritalStatusDisabled(false);
            setPincodeDisabled(false);
            setStateDisabled(false);
            setCityDisabled(false);
            setPersonalEmailDisabled(false);
            setPanDisbaled(true);
            setName(
              response.response.data.firstName +
                " " +
                response.response.data.middleName +
                " " +
                response.response.data.lastName
            );
            // setCustomerDetails({
            //   ...customerDetails,
            //   full_name:
            //     response.response.data.firstName +
            //     " " +
            //     response.response.data.middleName +
            //     " " +
            //     response.response.data.lastName,
            //   // "pan_no": pan_no,
            // });
            if (response.response.data.panTitle === "Shri") {
              setGender("Male");
            } else {
              setGender("Female");
            }
          }
        } else if (response.response.Success === false) {
          if (response.response.Message === "NSDL_REJECT") {
            // console.log(">>>>>>>>>>>>>>HERE<<<<<<<<<<<<<<<<<");
            setShowShimmer(true);
            // setActivePanRejection(true);
            setPanValidationReject(true);
          } else if (response.response.Message === "NSDL_FAILED") {
            setNsdlFailed(true);
          }
          setPAN("");
          setPANError(true);
          setPANErrorMessage("Please enter Valid PAN");
          setPANVerified(false);
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          }
          console.error(`Unknown Error: ${error}`);
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      if (error.message === "API call cancelled due to connectivity issue") {
        setInternetCheck(true);
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            63,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            63,
            customerDetails.application_form_number
          );
        }
        console.error(`Unknown Error: ${error}`);
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    }
    // setPANError(false);
    // setPANVerified(true);
  };

  const updatePAN = async (e) => {
    // console.log("Inside updatePAN");
    if (e.target.value.length <= 10) {
      e.target.value = e.target.value.toLocaleUpperCase();
      // console.log("updatePAN: e.target.value => ", e.target.value);
      setPAN(e.target.value);
      // Check if the 4th character is 'P'
      if (e.target.value.length === 10 && e.target.value.charAt(3) !== 'P') {
        setPANError(true);
        setPANErrorMessage("Please enter a personal PAN");
        return;
      }
      if (isValidPAN(e.target.value)) {
        // console.log("PAN is valid");
        // console.log(PAN);
        setPANError(false);
        // await callNSDL(e.target.value);
      } else {
        setPANError(true);
        setPANErrorMessage("Please enter Valid PAN");
        setPANVerified(false);
      }
    } else {
      e.target.value = PAN;
    }
  };

  const updateCity = (e) => {
    if (String(e.target.value).length <= 6) {
      setCity(e.target.value);
      // if (isValidPincode(e.target.value)) {
      //   setCityError(false);
      //   setCityVerified(false);
      // } else {
      //   setCityError(true);
      //   setCityVerified(false);
      //   setCityErrorMessage('Incorrect State');
      // }
    } else {
      e.target.value = pincode;
    }
  };

  const updateState = (e) => {
    if (String(e.target.value).length <= 6) {
      setState(e.target.value);
      // if (isValidPincode(e.target.value)) {
      //   setStateError(false);
      //   setStateVerified(false);
      // } else {
      //   setStateError(true);
      //   setStateVerified(false);
      //   setStateErrorMessage('Incorrect State');
      // }
    } else {
      e.target.value = pincode;
    }
  };

  const updatePincode = async (e) => {
    setPincode(e.target.value.slice(0, 6));
    if (String(e.target.value).length < 6) {
      // console.log("");
      setPincodeError(true);
      setPincodeVerified(false);
      setPincodeServiceableButtonDisabled(true);
      setPincodeInfoMessage("Required so we can service you better");
      setPincodeErrorMessage("Incorrect Pincode");
      // Dummy Code
      setCity("");
      setState("");
    } else if (String(e.target.value).length === 6) {
      if (isValidPincode(e.target.value)) {
        setPincodeError(false);
        setPincodeVerified(false);
        setPincodeServiceableButtonDisabled(false);
        // Dummy Code
        await pinCodeMaster(e.target.value);
      }
    }
  };

  const pinCodeMaster = async (pincode) => {
    try {
      const payload = {
        pincode: pincode,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + PINCODE_MASTER,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        setShowShimmer(false);
        if (response.response.Success === true) {
          if (response.response.Data.pl_serviceable == 0) {
            setPincodeError(true);
            setPincodeMasterError(true);
            setPincodeErrorMessage("Incorrect Pincode");
            setPincodeVerified(false);
            setCity("");
            setState("");
          } else {
            setCity(response.response.Data.city);
            setState(response.response.Data.state);
          }
        } else {
          setPincodeError(true);
          setPincodeMasterError(true);
          setPincodeVerified(false);
          setPincodeServiceableButtonDisabled(true);
          setPincodeInfoMessage("Required so we can service you better");
          setPincodeErrorMessage("Incorrect Pincode");
          setCity("");
          setState("");
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              63,
              customerDetails.application_form_number
            );
          }
          console.error(`Unknown Error: ${error}`);
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          63,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          63,
          customerDetails.application_form_number
        );
      }
      // console.log(error);
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const handleProceedClick = async() => {
    const payload = {
      personal_authorization_for_contact: personalAuthContact,
      personal_income_confirmation: personalIncomeConfirm,
    };
    
    const src = customerDetails?.source;
    await userConsentStatus(payload, src);

        if(customerDetails.source === "upsell"){
          await callSaveBasicDetailsAPI();
        }
        else{
          await verifyPANV2();
        }
  }

  const allFieldsValidated = () => {
    // console.log(
    //   "validity",
    //   consentCheckbox,
    //   isValidPAN(PAN),
    //   isValidEmail(personalEmail),
    //   isValidPincode(pincode),
    //   isValidDateOfBirth(dob)
    // );
    if (customerDetails?.source === "upsell") {
      return (
        consentCheckbox &&
        consentCheckbox2 &&
        isValidPAN(PAN) &&
        isValidEmail(personalEmail) &&
        isValidPincode(pincode) &&
        isValidDateOfBirth(dob) &&
        gender != "" &&
        maritalStatus != "" &&
        !nameError  &&
        fullName.length != 0 &&
        city != "" &&
        state != ""
      );
    } else {
      return (
        consentCheckbox &&
        consentCheckbox2 &&
        isValidPAN(PAN) &&
        !PANError &&
        isValidEmail(personalEmail) &&
        isValidPincode(pincode) &&
        gender != "" &&
        maritalStatus != "" &&
        dob != "" &&
        !dobError &&
        !nameError && 
        fullName.length != 0 &&
        residentialAddress &&
        residentialAddress1 &&
        !residentialAddressError &&
        !residentialAddress1Error &&
        city != "" &&
        state != ""
      );
    }
  };

  return (
    <>
      {/* <ProgressBar
        showProgress={true}
        currentStep={1}
        showText={false}
      /> */}
      <>
        <ScenarioBasedBottomModal
          id="bd-modal"
          confetti_className="conatiner js-container"
          isOpen={showBottomModal}
          showCloseButton={false}
          showConfettiEffect={true}
          closeButtonStyle={{ backgroundColor: "transparent" }}
          onClose={() => {
            // // console.log("Closing Bottom Modal");
            // setNoOffer(false);
            setShowBottomModal(false);
            // navigate("/reference", {
            //   replace: true,
            // });
          }}
          modalMessageHeading={`Congratulations ${
            customerDetails?.Data?.first_name === "None"
              ? ""
              : customerDetails?.Data?.first_name
          }!`}
          modalMessageHeadingStyle={{ color: "black" }}
          modalMessage={
            customerDetails.source === "upsell"
              ? "You are eligible for an Top-Up loan of up to"
              : "You are eligible for an Instant loan of up to"
          }
          modalMessageStyle={{ color: "#747474" }}
          modalMessage2={"₹" + approvedLoanAmount.toLocaleString("en-IN")}
          modalMessage2Style={{
            color: "#CB3443",
            fontWeight: "bold",
            fontSize: "30px",
          }}
          modalSubmitMessage="OK"
          modalStyle={{
            borderRadius: "0px",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            margin: "0px",
            width: "100%",
            height: "30%",
          }}
          style={{ alignItems: "flex-end" }}
          onModalSubmit={() => {
            // // console.log("Closing Bottom Modal");
            // setNoOffer(false);
            setShowBottomModal(false);
            // navigate("/reference", {
            //   replace: true,
            // });
          }}
        />
        <VerifyNameOnPANModal
          name={fullName}
          isOpen={showVerifyNameModal}
          onClose={() => {
            setShowVerifyNameModal(false);
          }}
        />
        <RejectActivePANModal
          isOpen={activePanRejection}
          onClose={() => {
            setActivePanRejection(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <IncorrectPinCodeModal
          isOpen={pincodeMasterError}
          onClose={() => {
            setPincode();
            setPincodeMasterError(false);
          }}
        />
        {/* <NsdlPanFailed isOpen={nsdlFailed} onClose={() => {}} /> */}
        <CheckInternetModal
          isOpen={internetCheck}
          onClose={() => {
            setInternetCheck(false);
            setShowShimmer(false);
          }}
        />

        <PanValidationReject
          isOpen={panValidationReject}
          onClose={() => {
            // setActivePanRejection(false);
            setPanValidationReject(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />

        <NsdlPanFailed
          isOpen={nsdlFailed}
          onClose={() => {
            setNsdlFailed(false);
            setPAN("");
            setPANError(true);
            setPANErrorMessage("Please enter Valid PAN");
            // setPANVerified(false);
          }}
        />

        <NsdlApiDown
          isOpen={nsdlDown}
          onClose={() => {
            setNsdlDown(false);
            setPAN("");
            setPANError(true);
            setPANErrorMessage("Please try after some time.");
            // setPANVerified(false);
          }}
        />

        <Loading open={modal === "LOADING"} />
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <PersonalDetailsWrapper className="first-child">
          <form className="basic-form">
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                disabled={panDisabled}
                visible={!showShimmer}
                on_change={updatePAN}
                error={PANError}
                error_message={PANErrorMessage}
                value={PAN}
                type={"text"}
                label={"PAN"}
                class_name={iosStyle}
              />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={fullName}
                disabled={false}
                error={nameError}
                on_change={(e) => {
                  updateName(e);
                }}
                type={"text"}
                label={
                  <span>
                    Full Name <i>(as per PAN)</i>
                  </span>
                }
                error_message={nameErrorMessage}
                on_blur={(e) => {
                  e.target.placeholder = "";
                }}
                on_focus={(e) => {
                  e.target.placeholder = "Enter full name as per PAN";
                }}
              />
            </div>
            <div
              style={{
                display: showShimmer ? "none" : "flex",
                width: "100%",
                justifyContent: "space-evenly",
              }}
              className={"additional-confirm"}
            >
              <form style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    fontSize: "18px",
                    color: "#747474",
                  }}
                >
                  Gender
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    type="radio"
                    id="additional-yes"
                    name="confirm-additional-detail"
                    checked={gender === "Male"}
                    value={"Male"}
                    disabled={maleDisabled}
                    onChange={updateGender}
                  />
                  <label for="additional-yes">Male</label>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    type="radio"
                    id="additional-no"
                    name="confirm-additional-detail"
                    checked={gender === "Female"}
                    disabled={femaleDisabled}
                    value={"Female"}
                    onChange={updateGender}
                  />
                  <label for="additional-no">Female</label>
                </div>
              </form>
            </div>

            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                id="date"
                visible={!showShimmer}
                value={dob}
                on_change={updateDateOfBirth}
                on_blur={(e) => {
                  e.target.placeholder = "";
                }}
                on_focus={(e) => {
                  e.target.placeholder = "DDMMYYYY";
                }}
                // type={"date"}
                type={dobType ? "text" : "numText"}
                label={"Date Of Birth"}
                error={dobError}
                disabled={dobDisabled}
                inputPaddingLeft={isUpsellDOb ? 10 : 95}
                error_message="Invalid date of birth"
                dateIcon={
                  <>
                    <img
                      src={CalendarIcon}
                      alt="PictureIcon.svg"
                      height="20"
                      width="20"
                    />
                  </>
                }
              />
              {dobDisabled === false && !showShimmer ? (
                <>
                  <div
                    style={{
                      paddingBottom: "5px",
                      paddingLeft: "10px",
                      color: "#6C7174",
                    }}
                  >
                    Please enter your date of birth as per your PAN CARD
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="basic-form-input ">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                // on_change={(e) => {
                //   dropDownChange(e.target.value);
                // }}
                type={"text"}
                value={maritalStatus}
                error={maritalStatusError}
                error_message="Select status"
                label={"Marital Status"}
                disabled={maritalStatusDisabled}
                options={dropDownOptions}
              />
            </div>
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={personalEmail}
                disabled={personalEmailDisabled}
                on_change={updatePersonalEmail}
                error_message="Please enter a valid email"
                error={personalEmailError}
                type="email"
                label={"Personal Email Address"}
              />
            </div>
            {customerDetails?.source === "epl" ?
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={residentialAddress}
                on_change={updateResidentialAdd}
                error={residentialAddressError}
                error_message={residentialAddressErrorMessage}
                type="text"
                label={"Flat No/House No/Building No"}
              />
            </div>
            : <></>
            }
            {customerDetails?.source === "epl" ?
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={residentialAddress1}
                on_change={updateResidentialAdd1}
                error={residentialAddress1Error}
                error_message={residentialAddress1ErrorMessage}
                type="text"
                label={"Building Name/Street/Locality"}
              />
            </div>
            : <></>
            }
            <div className="basic-form-input">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                value={pincode}
                on_change={updatePincode}
                error={pincodeError}
                error_message="Please enter a valid pin code"
                type="Number"
                label={"Communication Pincode"}
                disabled={pincodeDisabled}
              />
            </div>
            <div className="basic-form-input basic-form-input-small">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                disabled={true}
                type={"text"}
                value={city}
                label={"City"}
              />
            </div>
            <div className="basic-form-input basic-form-input-small">
              <ShimmerPlaceholder visible={showShimmer} />
              <FloatingInput
                visible={!showShimmer}
                disabled={true}
                type={"text"}
                value={state}
                label={"State"}
              />
            </div>
          </form>
          <div className={"basic-form-img bottomDiv"}>
            <ShimmerPlaceholder
              visible={showShimmer}
              height="2.5em"
              width="7em"
            />
          </div>
          <div
            style={{ display: showShimmer ? "none" : "flex" }}
            className={"professional-form-img bottomDiv"}
          >
            <CheckField
              id="basic-ckeckfield"
              checked={consentCheckbox}
              label="I hereby authorize Aditya Birla Capital Limited to collect, store, verify my credit bureau report and KYC details (from CERSAI / Digilocker), and contact me through SMS/Whatsapp/call with reference to my loan application."
              style={{
                fontSize: "1.4rem",
              }}
              onClick={updateConsentCheckbox}
            />
            <CheckField
              id="basic-ckeckfield"
              checked={consentCheckbox2}
              label="I understand and agree that Lenders doesn’t grant any microfinance loans and further, I hereby confirm that my annual household Income is more than 3 Lakh."
              style={{
                fontSize: "1.4rem",
              }}
              onClick={updateConsentCheckbox2}
            />
            <p style={{ marginLeft: "2.1rem", lineHeight: "16px" }}>
              *Annual household income refers to the yearly income of the entire
              household
            </p>

            <Button
              id="ProceedBtn"
              className="Btn ProceedBtn"
              disabled={!allFieldsValidated()}
              mobile={isMobile}
              onClick={
                handleProceedClick
              }
              onClickAdditional={() => {
                // Trigger Facebook Pixel code
                window.fbq("track", "PL_Mobile_Final_Button");
                window.gtag_report_conversion();
              }}
              // 	// history.replace({
              // 	//   pathname: `/professional`,
              // 	//   search: location.search,
              // 	// });
              // }}
              text={"Proceed"}
            />
          </div>
        </PersonalDetailsWrapper>
      </>
    </>
  );
};

export default PersonalDetails;
